
<template>
    <b-overlay :show="is_load" rounded="sm">
        <div class="direct_zones_block">
            <div class="import_row">
                <label class="form-label">{{__t('GOOGLE_MAP_URL')}}</label>
                <div class="import_row_inner">
                    <input type="text" v-model="google_url" class="form-control map_url_input" id="basic-url">
                    <button type="button" @click="importGoogle" class="btn btn-primary import_btn waves-effect waves-themed">
                        {{ __t('IMPORT') }}
                    </button>
                </div>
            </div>

            <div class="map_and_zones">
                <div class="map_col">
                    <div class="rest_zones">
                        <div id="map"></div>
                    </div>
                </div>

                <div class="zones_col">
                    <b-overlay :show="is_load_save" rounded="sm">

                        <div class="new_zone_card" v-if="active_feature && acitve_zone_id === 0">
                            <div class="new_zone_card_title">{{__t('FILTER_RESTAURANTS')}}</div>

                            <div class="form-group" v-if="restaurants.length > 0">
                                <v-select
                                    v-model="active_rest_id"
                                    class="imc_reasons"
                                    id="linked_rest"
                                    label="title"
                                    :clearable="false"
                                    :reduce="rest => rest.id"
                                    :filter="searchRest"
                                    :options="restaurants"
                                    >
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                <div>
                                                    {{ option.title }}
                                                </div>
                                                <div>
                                                    <small>
                                                        {{option.uniq_id}} {{option.address}}
                                                    </small>
                                                </div>
                                            </div>
                                        </template>
                                </v-select>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="form-label">{{__t('DELIVERY_TIME')}}</label>
                                        <input type="number" v-model.number="edit_time" class="form-control">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="form-label">{{__t('ZONE_COST')}}</label>
                                        <input type="number" v-model.number="edit_cost" class="form-control">
                                    </div>
                                </div>
                            </div>

                            <div class="zone_edit_actions">
                                <button type="button" @click="saveZone(true)" class="btn btn-primary flex-grow-2 waves-effect waves-themed">
                                    {{ __t('SAVE') }}
                                </button>
                                <button type="button" @click="cancelEdit" class="btn btn-light flex-grow-1 waves-effect waves-themed">
                                    {{ __t('CANCEL') }}
                                </button>
                            </div>
                        </div>

                        <div v-if="grouped_zones.length === 0 && !(active_feature && acitve_zone_id === 0)" class="no_zones">
                            {{ __t('NO_DATA') }}
                        </div>

                        <div class="rest_group" v-for="group in grouped_zones" :key="group.rest_id">
                            <div class="rest_group_header" @click="toggleGroup(group.rest_id)">
                                <div class="rest_pin">
                                    <i class="fal fa-map-marker-alt"></i>
                                </div>
                                <div class="rest_group_title">
                                    <div class="rest_title">{{ group.rest_title }}</div>
                                    <div class="rest_zone_count">{{ group.zones.length }} {{ __t('ZONES_COUNT') }}</div>
                                </div>
                                <i class="fal" :class="expanded_rest_id === group.rest_id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </div>

                            <div class="rest_group_zones" v-show="expanded_rest_id === group.rest_id">
                                <div
                                    class="zone_row"
                                    :class="{ active : is_active_zone(zone) }"
                                    :style="{ borderLeftColor : zone.color }"
                                    v-for="zone in group.zones"
                                    :key="zone.id"
                                    :data-zone-id="zone.id"
                                >
                                    <div class="zone_row_summary" @click="selectZone(zone)">
                                        <div class="zone_meta">
                                            <i class="fal fa-clock"></i> {{ zone.time }} {{ __t('MIN') }}
                                        </div>
                                        <div class="zone_meta">
                                            <i class="fal fa-wallet"></i> {{ zone.cost }} ₴
                                        </div>
                                        <i class="fal" :class="is_active_zone(zone) ? 'fa-chevron-up' : 'fa-chevron-right'"></i>
                                    </div>

                                    <div class="zone_edit" v-if="is_active_zone(zone)">
                                        <div class="row">
                                            <div class="col-6">
                                                <label class="form-label">{{__t('DELIVERY_TIME')}}</label>
                                                <input type="number" v-model.number="edit_time" class="form-control">
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label">{{__t('ZONE_COST')}}</label>
                                                <input type="number" v-model.number="edit_cost" class="form-control">
                                            </div>
                                        </div>

                                        <div class="zone_edit_actions">
                                            <button type="button" @click="saveZone(true)" class="btn btn-primary flex-grow-2 waves-effect waves-themed">
                                                {{ __t('SAVE') }}
                                            </button>
                                            <button type="button" @click="cancelEdit" class="btn btn-light flex-grow-1 waves-effect waves-themed">
                                                {{ __t('CANCEL') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </b-overlay>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>

import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import Fuse from 'fuse.js';
import vSelect from 'vue-select'

const ZONE_COLORS = ['#2F6FED', '#27AE60', '#F2994A', '#9B51E0', '#EB5757', '#17A2B8'];

let draw = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
        polygon: true,
        trash: true,
        defaultMode: 'draw_polygon',
        userProperties: true,
    },
});
mapboxgl.accessToken = "pk.eyJ1IjoibG9payIsImEiOiJjamh6dnF4cGwwM3JtM3BwaTg4b28zNXdhIn0.OvClW1t-Lxss_VhXQHBAwQ";
const MAP_STYLE = "mapbox://styles/mapbox/light-v10";


export default {
    name: "pwa_map",
    components : {
        vSelect
    },

    data () {
        return {
            is_load : true,
            is_load_save : false,
            rest_features : [],
            active_feature : null,
            edit_time : 0,
            edit_cost : 0,
            expanded_rest_id : null,
            google_url : "",
            restaurants: [],

            map_opt : {
                center : [
                    50.1100291,
                    23.4703014
                ],
                attributionControl: false,
                preserveDrawingBuffer: true,
                hash: false,
                container : "map",
                style: "mapbox://styles/tbiliso/ckiufb2m82toh19oz1qjkywos",
                accessToken: "pk.eyJ1IjoibG9payIsImEiOiJjamh6dnF4cGwwM3JtM3BwaTg4b28zNXdhIn0.OvClW1t-Lxss_VhXQHBAwQ",
            },
            is_map_load : false,
        }
    },

    created() {
        this.mapbox = null;
        EventBus.$on('loaded_api',this.load_location_geo);
        this.load_restaurants();
    },

    mounted() {
        this.map = new mapboxgl.Map(this.map_opt);

        let self = this;
        this.map.on("load", function () {
            self.map_loaded = true;
            self.map.addControl(draw, "top-left");
            self.attach_zones();
            self.map.resize();
            self.is_load = false;
        });

        this.on_hover();

        this.map.on('draw.selectionchange',function(e) {
            self.onFeatureSelected(e.features[0] || null);
        });

        this.map.on('draw.update', function (e) {
            let updatedFeature = e.features[0];
            self.active_feature = updatedFeature;
        });

        this.map.on('draw.create', this.updateCreateArea);
    },

    watch : {
        active_feature(feature) {
            if(!feature) {
                return;
            }

            this.$nextTick(() => {
                const el = this.$el.querySelector('[data-zone-id="' + feature.id + '"]');
                if(el) {
                    el.scrollIntoView({behavior : 'smooth', block : 'nearest'});
                }
            });
        }
    },

    methods : {

        on_hover() {
            this.map.on('mouseenter', 'stored-polygons', (e) => {
                this.map.getCanvas().style.cursor = 'pointer';

                const { rest_title = 'No title', cost = 0, time = 0 } = e.features[0].properties || {};
                const coordinates = e.lngLat;

                this.popup = new mapboxgl.Popup({
                    closeButton: false,
                    closeOnClick: false
                })
                    .setLngLat(coordinates)
                    .setHTML(`<strong>${rest_title}</strong><br/>${this.__t('DELIVERY_TIME')} : ${time} ${this.__t('MIN')}<br/>${this.__t('ZONE_COST')} : ${cost}`)
                    .addTo(this.map);
            });

            this.map.on('mouseleave', 'stored-polygons', () => {
                this.map.getCanvas().style.cursor = '';
                if (this.popup) {
                    this.popup.remove();
                    this.popup = null;
                }
            });
        },

        onFeatureSelected(feature) {
            this.active_feature = feature;

            if(feature) {
                this.edit_time = feature.properties?.time || 0;
                this.edit_cost = feature.properties?.cost || 0;
                this.expanded_rest_id = feature.properties?.rest_id || 0;
            }
            else {
                this.edit_time = 0;
                this.edit_cost = 0;
            }
        },

        selectZone(zone) {
            if(this.is_active_zone(zone)) {
                this.deselectFeature();
                return;
            }

            draw.changeMode('simple_select', { featureIds : [zone.feature.id] });
            this.onFeatureSelected(zone.feature);
            this.flyToFeature(zone.feature);
        },

        deselectFeature() {
            draw.changeMode('simple_select');
            this.active_feature = null;
            this.edit_time = 0;
            this.edit_cost = 0;
        },

        cancelEdit() {
            if(this.active_feature && this.acitve_zone_id === 0) {
                draw.delete(this.active_feature.id);
            }

            this.deselectFeature();
        },

        toggleGroup(rest_id) {
            this.expanded_rest_id = this.expanded_rest_id === rest_id ? null : rest_id;
        },

        is_active_zone(zone) {
            return !!this.active_feature && this.active_feature.id === zone.id;
        },

        flyToFeature(feature) {
            const coords = feature.geometry?.coordinates?.[0];
            if(!coords || coords.length === 0) {
                return;
            }

            let minLng = Infinity, minLat = Infinity, maxLng = -Infinity, maxLat = -Infinity;
            coords.forEach(([lng, lat]) => {
                if (lng < minLng) minLng = lng;
                if (lat < minLat) minLat = lat;
                if (lng > maxLng) maxLng = lng;
                if (lat > maxLat) maxLat = lat;
            });

            this.map.fitBounds([[minLng, minLat], [maxLng, maxLat]], { padding: 60, maxZoom: 15 });
        },

        updateCreateArea(e) {
            if (!e.features || e.features.length === 0) return;

            let feature = e.features[0];

            if (!feature.properties) {
                feature.properties = {};
            }

            feature.properties.zone_id ??= 0;
            feature.properties.cost ??= 0;
            feature.properties.time ??= 0;
            feature.properties.rest_id ??= 0;

            draw.setFeatureProperty(feature.id, 'zone_id', feature.properties.zone_id);
            draw.setFeatureProperty(feature.id, 'cost', feature.properties.cost);
            draw.setFeatureProperty(feature.id, 'time', feature.properties.time);
            draw.setFeatureProperty(feature.id, 'rest_id', feature.properties.rest_id);

            this.onFeatureSelected(feature);
        },

        async saveZone(refresh) {
            if(!this.active_feature) {
                return;
            }

            this.active_feature.properties.time = this.edit_time;
            this.active_feature.properties.cost = this.edit_cost;

            this.is_load_save = true;
            await api.patch('/internal/v1/catalog/restaurants/'+ this.active_rest_id +'/geo/features/'+ this.acitve_zone_id,this.active_feature).then(({data}) => {
                if (data.status === "operation_success") {
                    this.is_load_save = false;
                    if(refresh) {
                        this.active_feature = null;
                        this.edit_time = 0;
                        this.edit_cost = 0;
                        draw.deleteAll();
                        this.attach_zones();
                    }
                }
            }).catch(({response}) => {
                this.is_load_save = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        attach_zones() {
            this.is_load = true;
            this.load_location_geo().then(({data}) => {
                let resp = data.data;
                if(resp.hasOwnProperty('featuresCollection')) {
                    this.rest_features = resp.featuresCollection.features;
                    this.assignZoneColors();
                    this.draw_rest_zones();

                    if(this.grouped_zones.length > 0) {
                        this.expanded_rest_id = this.grouped_zones[0].rest_id;
                    }

                    this.is_load = false;
                }
            });
        },

        assignZoneColors() {
            let counts = {};

            this.rest_features.forEach((feature) => {
                if (!feature.properties) feature.properties = {};

                const rest_id = feature.properties.rest_id || 0;
                counts[rest_id] = counts[rest_id] || 0;

                feature.properties.user_color = ZONE_COLORS[counts[rest_id] % ZONE_COLORS.length];
                counts[rest_id]++;
            });
        },

        draw_rest_zones()
        {
            let feature_draw = {
                type: "FeatureCollection",
                features: []
            };
            let minLng = Infinity, minLat = Infinity, maxLng = -Infinity, maxLat = -Infinity;

            this.rest_features.map(feature => {
                feature_draw.features.push(feature);

                feature.geometry.coordinates[0].forEach(([lng, lat]) => {
                    if (lng < minLng) minLng = lng;
                    if (lat < minLat) minLat = lat;
                    if (lng > maxLng) maxLng = lng;
                    if (lat > maxLat) maxLat = lat;
                });
            });

            draw.add(feature_draw);
            this.work_layouts(feature_draw);


            const bounds = [[minLng, minLat], [maxLng, maxLat]];
            this.map.fitBounds(bounds, { padding: 20 });

            this.map.resize();
        },

        work_layouts(feature_draw) {
            if (this.map.getLayer('stored-polygons')) {
                this.map.removeLayer('stored-polygons');
            }

            if (this.map.getSource('rest_zones')) {
                this.map.removeSource('rest_zones');
            }

            this.map.addSource('rest_zones', {
                type: 'geojson',
                data: feature_draw
            });

            this.map.addLayer({
                id: 'stored-polygons',
                type: 'fill',
                source: 'rest_zones',
                layout: {},
                paint: {
                    'fill-color': ['get', 'user_color'],
                    'fill-opacity': 0.3
                },
                filter: ['==', '$type', 'Polygon']
            });

        },

        async importGoogle() {
            this.is_load_save = true;
            await api.patch('/internal/v1/catalog/restaurants/geo/features/google',{
                "url" : this.google_url
            }).then(({data}) => {
                this.is_load_save = false;
                if (data.status === "operation_success") {
                    const geojson = data.data;
                    this.renderImportedZone(geojson);
                }

            }).catch(({response}) => {
                this.is_load_save = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        renderImportedZone(geojson) {

            if (this.map.getSource('google_import')) {
                this.map.removeLayer('google_import_layer');
                this.map.removeSource('google_import');
            }

            this.map.addSource('google_import', {
                type: 'geojson',
                data: geojson
            });

            this.map.addLayer({
                id: 'google_import_layer',
                type: 'fill',
                source: 'google_import',
                layout: {},
                paint: {
                    'fill-color': '#0000FF',
                    'fill-opacity': 0.3,
                    'fill-outline-color': '#0000AA'
                }
            });

            geojson.features.forEach(f => {
                draw.add(f);
            });

            const bounds = new mapboxgl.LngLatBounds();
            geojson.features.forEach(feature => {
                feature.geometry.coordinates[0].forEach(coord => {
                    bounds.extend(coord);
                });
            });

            this.map.fitBounds(bounds, { padding: 20 });
        },

        async load_restaurants() {
            this.restaurants = [];
            await api.post('/internal/v1/catalog/restaurants', {
                "filter": {},
                "list": {
                    "limit": 100
                }
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.restaurants = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: ['title', 'uniq_id', 'address'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        async load_location_geo() {
            return  api.post('/internal/v1/catalog/restaurants/geo/features/skip/date',{});
        },
    },

    computed : {
        active_zone_prop() {
            if(this.active_feature) {
                if(this.active_feature.hasOwnProperty("properties")) {
                    return this.active_feature.properties;
                }
            }

            return {
                "zone_id" : 0,
                "cost" : 0,
                "time" : 0,
                "rest_id" : 0,
            }
        },

        acitve_zone_id () {
            if(this.active_zone_prop.hasOwnProperty("zone_id")) {
                return this.active_zone_prop.zone_id;
            }

            return 0;
        },

        active_rest_id: {
            get() {
                return this.active_feature?.properties?.rest_id || 0;
            },
            set(val) {
                if (this.active_feature && this.active_feature.properties) {
                    this.active_feature.properties.rest_id = parseInt(val);
                }
            }
        },

        grouped_zones() {
            let groups = [];
            let index_by_rest = {};

            this.rest_features.forEach((feature) => {
                const props = feature.properties || {};
                const rest_id = props.rest_id || 0;

                if(!(rest_id in index_by_rest)) {
                    index_by_rest[rest_id] = groups.length;
                    groups.push({
                        rest_id : rest_id,
                        rest_title : props.rest_title || '',
                        zones : [],
                    });
                }

                groups[index_by_rest[rest_id]].zones.push({
                    id : feature.id,
                    zone_id : props.zone_id || 0,
                    time : props.time || 0,
                    cost : props.cost || 0,
                    color : props.user_color || ZONE_COLORS[0],
                    feature : feature,
                });
            });

            return groups;
        },

    },

}
</script>


<style scoped>

.direct_zones_block {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.import_row_inner {
    display: flex;
    gap: 12px;
}

.map_url_input {
    border-radius: 8px;
}

.import_btn {
    border-radius: 8px;
    white-space: nowrap;
}

.map_and_zones {
    display: flex;
    gap: 16px;
    align-items: flex-start;
}

.map_col {
    flex: 1 1 65%;
    min-width: 0;
}

.map_col .rest_zones {
    height: 560px;
    border-radius: 12px;
    overflow: hidden;
}

.zones_col {
    flex: 0 0 340px;
    max-height: 560px;
    overflow-y: auto;
    padding-right: 4px;
}

.no_zones {
    padding: 24px;
    text-align: center;
    color: #9AA1AC;
}

.rest_group {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(20,20,43,0.08);
    margin-bottom: 12px;
    overflow: hidden;
}

.rest_group_header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    cursor: pointer;
}

.rest_pin {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #EAF1FF;
    color: #2F6FED;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.rest_group_title {
    flex: 1 1 auto;
    min-width: 0;
}

.rest_title {
    font-weight: 600;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rest_zone_count {
    font-size: 12px;
    color: #9AA1AC;
}

.rest_group_zones {
    border-top: 1px solid #EEF0F3;
}

.zone_row {
    border-left: 4px solid #2F6FED;
    border-bottom: 1px solid #F1F2F4;
    padding: 12px 16px;
}

.zone_row:last-child {
    border-bottom: none;
}

.zone_row.active {
    background: #F3FBF6;
}

.zone_row_summary {
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
}

.zone_meta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #4C5564;
}

.zone_row_summary .fa-chevron-right,
.zone_row_summary .fa-chevron-up {
    margin-left: auto;
    color: #9AA1AC;
}

.zone_edit {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed #E3E6EA;
}

.zone_edit .form-label {
    font-size: 12px;
    color: #9AA1AC;
}

.zone_edit_actions {
    display: flex;
    gap: 8px;
    margin-top: 12px;
}

.zone_edit_actions .flex-grow-2 {
    flex-grow: 2;
}

.zone_edit_actions .flex-grow-1 {
    flex-grow: 1;
}

.new_zone_card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(20,20,43,0.08);
    border: 1px dashed #2F6FED;
    padding: 16px;
    margin-bottom: 16px;
}

.new_zone_card_title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
}

</style>
